<script setup>
import {ref, onBeforeMount} from "vue"
import {voucherStateEnum} from "@/enum/voucherStateEnum.js"
const props = defineProps({
  state: {
    required: true,
    type: String,
    default: "INIT"
  }
})

// 执行订单判断
onBeforeMount(() => {
  handleEnum()
})

// 展示的文本类型
const textType = ref("info")
// 状态名称
const stateName = ref("未知状态")
// 订单状态枚举
const orderState = voucherStateEnum

// 根据枚举返回订单状态
const handleEnum = () => {
  try {
    const order = orderState.find(res => res.stateId === props.state)
    stateName.value = order.stateName ? order.stateName : "未知状态"
    switch (props.state) {
      case "AVAILABLE":
        textType.value = "primary"
        break
      case "USED":
        textType.value = "success"
        break
      case "EXPIRED":
        textType.value = "error"
        break
      case "CANCELLED":
        textType.value = "info"
        break
    }
  } catch (e) {
    console.log(e)
  }
}
</script>

<template>
  <el-text :type="textType" v-text="stateName"></el-text>
</template>

<style scoped>

</style>